import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import styles from './index.module.less'
import classNames from 'classnames'

interface InputNumberProps {
  /**库存 */
  max?: number
  value?: number
  onChange?: Function
  disabled?: boolean
  /**是否显示提示 */
  showTips?: boolean
}

const getValueWithMax = (value, max) => {
  return max && value > max ? max : value
}

export default function InputNumber({
  value,
  onChange,
  max,
  disabled,
  showTips = true,
}: InputNumberProps) {
  const [number, setNumber] = useState<number>(0)
  const hasMax = (max ?? 0) > 0
  const addDisabled = disabled || number === max || !hasMax
  const reduceDisabled = disabled || number === 1 || !hasMax
  const inputDisabled = disabled || !hasMax

  const onAdd = () => {
    if (!max || addDisabled) return

    let newValue = getValueWithMax(number + 1, max)
    setNumber(newValue)
    onChange?.(newValue)
  }

  const onReduce = () => {
    if (!max || reduceDisabled) return
    if (number === 0) return

    let newValue = getValueWithMax(number - 1, max)
    setNumber(newValue)
    onChange?.(newValue)
  }

  useEffect(() => {
    setNumber(value || 0)
  }, [value])

  return (
    <div className={styles.inputNumber}>
      <div className={styles.content}>
        <div
          className={classNames(
            styles.options,
            reduceDisabled && styles.disabled
          )}
          onClick={onReduce}
        >
          <span>-</span>
        </div>
        <div className={styles.input}>
          <input
            className={classNames(inputDisabled && styles.disabled)}
            disabled={inputDisabled}
            value={number}
            onChange={e => {
              let numValue = +e.target.value.replace(/[^0-9]/g, '')
              if (max && numValue > max) {
                message.warning('超过最大可加购数量，已为你自动调整')
                setNumber(getValueWithMax(numValue, max))
                onChange?.(getValueWithMax(numValue, max))
              } else {
                setNumber(numValue)
                onChange?.(getValueWithMax(numValue, max))
              }
            }}
          />
        </div>
        <div
          className={classNames(styles.options, addDisabled && styles.disabled)}
          onClick={onAdd}
        >
          <span>+</span>
        </div>
        {showTips && <p className={styles.stock}>{hasMax ? '有货' : '缺货'}</p>}
      </div>
    </div>
  )
}
